import {Component, OnDestroy, OnInit} from '@angular/core';
import {PortalDataService} from "../../services/portal-data/portal-data.service";
import {ReportDashboardModel} from "../../services/portal-data/report-dashboard.model";
import {UserService} from "../../services/user/user.service";
import {PermissionActionType, PermissionService} from "../../services/permission/permission.service";
import {$translate} from "../../services/internationalization/localize.service";
import {InternationalizationService} from "../../services/internationalization/internationalization.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'sb-report-dashboard-list',
  templateUrl: './report-dashboard-list.component.html',
  styleUrls: ['./report-dashboard-list.component.scss']
})
export class ReportDashboardListComponent implements OnInit, OnDestroy {

  showCreateMenuItem: boolean = true;

  constructor(private portalDataService: PortalDataService,
              private userService: UserService,
              private permissionService: PermissionService,
              private i18nService: InternationalizationService) { }

  privateDashboards: ReportDashboardModel[] = [];

  publicDashboards: ReportDashboardModel[] = [];

  private localeChanged$: Subscription;

  buttonLabel;
  privateLabel;
  publicLabel;
  createLabel;
  emptyLabel;

  async ngOnInit() {

    this.portalDataService.portalComponentsLoaded.subscribe((firstTime) => {
      this.updateList();
    });

    this.localeChanged$ = this.i18nService.localeChanged$.subscribe((locale: string) => {
      this.updateMessages();
    });

    this.updateList();

    this.updateMessages();

    const allowByPermission = await this.permissionService.evaluateUser("ReportDashboard", PermissionActionType.CREATE);

    const allowedRolesProperty = this.userService.parseCommaSeparatedProperty(this.userService.getProperty("dashboard.create.role_required", ""));

    const allowByProperty = allowedRolesProperty.filter( r => this.userService.hasRole(r)).length > 0;

    this.showCreateMenuItem = allowByPermission && (allowedRolesProperty.length == 0 || allowByProperty);
  }

  ngOnDestroy() {
    this.localeChanged$ && this.localeChanged$.unsubscribe();
  }

  updateList() {
    this.privateDashboards = this.portalDataService.getPrivateReportDashboards();
    this.publicDashboards = this.portalDataService.getPublicReportDashboards();
  }

  private updateMessages() {
    this.buttonLabel = $translate("ng.component.report-dashboard-list.button")`Dashboards`;
    this.privateLabel = $translate("ng.component.report-dashboard-list.private")`My Dashboards`;
    this.publicLabel = $translate("ng.component.report-dashboard-list.public")`All Dashboards`;
    this.createLabel = $translate("ng.component.report-dashboard-list.create")`Create dashboard`;
    this.emptyLabel = $translate("ng.component.report-dashboard-list.empty")`None available`;
  }

}
